<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 8 12"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.33333 0L0 7H4L2.66667 12L8 5H4L5.33333 0Z" :fill="fill"/>
  </svg>

</template>

<script>
export default {
  name: 'Lightning',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
